"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _StepperFooter = _interopRequireDefault(require("../../../../components/Stepper/StepperFooter"));

var _MessagingForm = _interopRequireDefault(require("../MessagingForm"));

var _components = require("../../../../components");

var _hooks = require("../../../../hooks");

var _providers = require("../../../../providers");

var _messaging = require("../../constants/messaging.helpers");

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var LoadingLogo = function LoadingLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.308 167.029c32.7 99.2 100.3 61.1 144.2 21.2 43.9-39.9 109.4-57 78.7-102.8-30.7-45.8-82.2-46.4-126.1-6.4-43.9 40-129.6-11.2-96.8 88z",
    fill: "#8ACCC5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 70.5c-50.194 77.427 13.457 102.876 65.229 111.012 51.771 8.136 99.802 43.764 114.339-2.725 14.537-46.489-13.559-82.277-65.399-90.358-51.84-8.08-64.031-95.424-114.17-17.929z",
    stroke: "url(#a)",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M115.89 127.306l-7.609.611c-.639.055-1.222-.445-1.278-1.084a1.154 1.154 0 0 1 .417-.999l5.777-4.944-.639-7.609c-.056-.639.444-1.222 1.083-1.278.389-.027.75.112 1 .417l4.971 5.777 7.609-.639c.639-.056 1.222.444 1.278 1.083.027.389-.111.75-.417 1l-5.776 4.971.611 7.609c.055.639-.445 1.222-1.084 1.278a1.151 1.151 0 0 1-.999-.417l-4.944-5.776z",
    fill: "#33467D"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M147.884 171.212a4.5 4.5 0 1 0 0-8.999 4.5 4.5 0 0 0 0 8.999z",
    stroke: "#23BCB7",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M123.5 160.493l-2.111 3.721c-.194.333-.611.444-.972.25-.111-.083-.222-.167-.277-.305l-1.833-3.889a3.492 3.492 0 0 0-2.444-1.916l-4.194-.888c-.388-.084-.611-.445-.555-.834a.77.77 0 0 1 .194-.361l3.111-2.943a3.492 3.492 0 0 0 1.083-2.916l-.472-4.249c-.056-.389.25-.723.611-.778a.57.57 0 0 1 .416.083l3.777 2.055a3.501 3.501 0 0 0 3.111.111l3.915-1.749a.673.673 0 0 1 .917.361c.055.139.083.278.055.416l-.777 4.222a3.48 3.48 0 0 0 .861 2.999l2.888 3.194c.25.277.25.722-.056 1-.111.083-.25.166-.388.166l-4.249.556a3.455 3.455 0 0 0-2.611 1.694z",
    fill: "#F4D138"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M145.272 136.72l-10.275-8.554a1.4 1.4 0 0 1-.195-1.944 1.43 1.43 0 0 1 1.167-.5l13.358.861 8.554-10.275a1.4 1.4 0 0 1 1.944-.195c.333.278.527.723.5 1.167l-.861 13.33 10.275 8.554a1.4 1.4 0 0 1 .195 1.944 1.427 1.427 0 0 1-1.167.5l-13.358-.861-8.554 10.275a1.4 1.4 0 0 1-1.944.195 1.429 1.429 0 0 1-.5-1.167l.861-13.33z",
    fill: "#3D97D3"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "a",
    x1: "189.932",
    y1: "82.654",
    x2: "66.023",
    y2: "182.286",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#029CEF",
    stopOpacity: ".99"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#15998C"
  }))));
};

LoadingLogo.defaultProps = {
  width: "261",
  height: "265",
  viewBox: "0 0 261 265",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  pollingTitle: {
    fontSize: 20,
    lineHeight: '24px',
    color: 'text.main',
    my: 2
  },
  progress: {
    height: 10,
    borderRadius: 1,
    color: 'primary.main'
  }
};

var MessagingPanel = function MessagingPanel() {
  var trackGiftingFlowMessageStepNextButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowMessageStepNextButtonClicked)();

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGiftingFlowSteps = (0, _hooks.useGiftingFlowSteps)(),
      goToNextStep = _useGiftingFlowSteps.goToNextStep;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId: Number(batchId)
  } : _query.skipToken),
      batch = _useGetProspectingBat.data,
      isBatchFulfilled = _useGetProspectingBat.isSuccess;

  var isBatchGiftsCreated = (batch === null || batch === void 0 ? void 0 : batch.giftsCreationStatus) === _services.ProspectingBatchGiftsStatus.Finished;
  var isBatchGiftsPending = (batch === null || batch === void 0 ? void 0 : batch.giftsCreationStatus) === _services.ProspectingBatchGiftsStatus.Pending;
  var isBatchGiftsIdle = (batch === null || batch === void 0 ? void 0 : batch.giftsCreationStatus) === _services.ProspectingBatchGiftsStatus.Idle;

  var _useGetProspectingBat2 = (0, _services.useGetProspectingBatchStatusByIdQuery)(batchId && isBatchGiftsPending ? {
    batchId: Number(batchId)
  } : _query.skipToken, {
    pollingInterval: isBatchGiftsPending ? 1000 : 0
  }),
      batchStatus = _useGetProspectingBat2.data,
      isBatchGiftsStatusFulfilled = _useGetProspectingBat2.isSuccess;

  var _usePutProspectingBat = (0, _services.usePutProspectingBatchMessagingByIdMutation)(),
      _usePutProspectingBat2 = (0, _slicedToArray2.default)(_usePutProspectingBat, 2),
      updateMessaging = _usePutProspectingBat2[0],
      _usePutProspectingBat3 = _usePutProspectingBat2[1],
      isPending = _usePutProspectingBat3.isLoading,
      isMessagingUpdateFulfilled = _usePutProspectingBat3.isSuccess;

  var _useCreateProspecting = (0, _services.useCreateProspectingBatchGiftsByIdMutation)(),
      _useCreateProspecting2 = (0, _slicedToArray2.default)(_useCreateProspecting, 2),
      createGiftsByBatchId = _useCreateProspecting2[0],
      _useCreateProspecting3 = _useCreateProspecting2[1],
      isGiftsCreatePending = _useCreateProspecting3.isLoading,
      isCreateBatchGiftsFulfilled = _useCreateProspecting3.isSuccess;

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      showGlobalMessage = _GlobalMessage$useGlo.showGlobalMessage;

  var progress = (0, _react.useMemo)(function () {
    return batchStatus && batchStatus.total > 0 ? Math.ceil(batchStatus.created * 100 / batchStatus.total) : 0;
  }, [batchStatus]);
  var isSaveProcessPending = isPending || isGiftsCreatePending;
  var handleUpdateMessaging = (0, _react.useCallback)(function (data, _ref) {
    var isDirty = _ref.isDirty;
    var body = (0, _messaging.formValueToData)(data);
    trackGiftingFlowMessageStepNextButtonClicked(body);

    if (isBatchGiftsCreated && !isDirty) {
      goToNextStep();
      return;
    }

    if (batchId) {
      updateMessaging({
        batchId,
        body
      }).unwrap().then(function () {
        if (isBatchFulfilled && isBatchGiftsIdle && batchId) {
          createGiftsByBatchId({
            batchId: Number(batchId)
          });
        }

        showGlobalMessage({
          type: _services.MessageType.Success,
          text: 'Message updated successfully'
        });
      });
    }
  }, [batchId, isBatchFulfilled, isBatchGiftsIdle, isBatchGiftsCreated, goToNextStep, createGiftsByBatchId, updateMessaging, showGlobalMessage, trackGiftingFlowMessageStepNextButtonClicked]);
  (0, _react.useEffect)(function () {
    if (isBatchGiftsCreated && (isMessagingUpdateFulfilled || isBatchGiftsStatusFulfilled || isCreateBatchGiftsFulfilled)) {
      goToNextStep();
    }
  }, [isBatchGiftsCreated, isMessagingUpdateFulfilled, goToNextStep, isBatchGiftsStatusFulfilled, isCreateBatchGiftsFulfilled]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 4
  }, isBatchGiftsPending ? /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.pollingTitle
  }, "Generating your gift invites for a final preview...") : /*#__PURE__*/_react.default.createElement(_components.StepTitle, {
    title: "Set Message",
    subTitle: "Step 3/4"
  }), /*#__PURE__*/_react.default.createElement(_material.Paper, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    px: 2,
    py: 3
  }, isBatchGiftsPending ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    minHeight: 300,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(LoadingLogo, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    mt: 4
  }, /*#__PURE__*/_react.default.createElement(_material.LinearProgress, {
    sx: styles.progress,
    variant: "determinate",
    value: progress
  }))) : /*#__PURE__*/_react.default.createElement(_MessagingForm.default, {
    isMessagingPending: isPending,
    isGiftsCreatePending: isGiftsCreatePending,
    onSubmit: handleUpdateMessaging
  }, /*#__PURE__*/_react.default.createElement(_StepperFooter.default, {
    isLoading: isSaveProcessPending,
    disabled: isPending
  })))));
};

var _default = MessagingPanel;
exports.default = _default;